<div id="species-container" class="variables">
  <mat-selection-list [multiple]="false" hideSingleSelectionIndicator=true class="selection-list">
    <mat-list-option *ngFor="let s of speciesService.allShortenSpecies()" [value]="s"
                     (click)="onSpeciesChange(s)" [selected]="s.taxId === speciesService.currentSpecies().taxId">
      <div class="species">
        <mat-icon class="custom-icon" [svgIcon]="s.taxId"></mat-icon>
        <span>{{ s.displayName }}</span>
      </div>
    </mat-list-option>
  </mat-selection-list>
</div>
